var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLessEquals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6B7280",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 12.226562 2.550781 C 12.472656 2.882812 12.40625 3.351562 12.074219 3.601562 L 6.875 7.5 L 12.074219 11.398438 C 12.40625 11.648438 12.472656 12.117188 12.226562 12.449219 C 11.976562 12.78125 11.507812 12.847656 11.175781 12.601562 L 5.175781 8.101562 C 4.984375 7.957031 4.875 7.734375 4.875 7.5 C 4.875 7.265625 4.984375 7.042969 5.175781 6.898438 L 11.175781 2.398438 C 11.507812 2.152344 11.976562 2.21875 12.226562 2.550781 Z M 4.875 15 C 4.875 14.585938 5.210938 14.25 5.625 14.25 L 12.375 14.25 C 12.789062 14.25 13.125 14.585938 13.125 15 C 13.125 15.414062 12.789062 15.75 12.375 15.75 L 5.625 15.75 C 5.210938 15.75 4.875 15.414062 4.875 15 Z M 4.875 15 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessEquals);
export default __webpack_public_path__ + "static/media/less_equals.0869fe7b4a1bbdf7a419b13d94fae730.svg";
export { ForwardRef as ReactComponent };